import { buildURL, callApi, Urls } from "../../helpers/api-urls";

export const getFormFocusAreaOptions = async () => {
  const response = await callApi.get(buildURL(`${Urls.GetFocusAreaOptions}`));

  return {
    data: Array.isArray(response.responseData) ? response.responseData.map((d) => ({ label: d.name, value: d.code?.trim() || "" })) : [],
  };
};
